export default {
  setLiveRooms(state, rooms) {
    state.liveRooms = [{_id: null,title: 'Main room'},...rooms];
  }
}